import { Box, Typography, TextField, FormControl, FormControlLabel, Checkbox, Button, Grid, Divider, Radio, RadioGroup, FormLabel, FormGroup, Paper } from '@mui/material';

const t = {
    en: {
        title: 'Express Entry Questionnaire - Spouse',
        switchLabel: 'Switch to French',
        accompany: 'Will you accompany the principal applicant to Canada?',
        citizen: 'Are you a Canadian Citizen or Permanent Resident of Canada?',
        relative: 'Do you have a relative who is citizen or permanent resident of Canada (The relative must be 18 or older and living in Canada.)',
        lastName: 'Last Name(s)',
        firstName: 'First Name(s)',
        gender: 'Gender',
        dob: 'Date of Birth (yyyy-mm-dd)',
        pob: 'Place of Birth (Country/City)',
        educationTitle: 'Education History',
        eduQuestion: 'Have you finished high school or any higher education (including university, college or vocational training)? Please answer all the following questions for each secondary and post-secondary periods of study :',
        school: 'Name of School/Institution',
        field: 'Field of Study',
        place: 'Place of Study (Country/Province/City)',
        postal: 'Postal Code',
        duration: 'Study Duration (from–to)',
        languages: 'Official Languages',
        communicate: 'Can you communicate in English and/or French?',
        workTitle: 'Work History',
        workingInCanada: 'Are you currently working in Canada?',
        period: 'Work Period',
        hours: 'Hours per week',
        noc: 'NOC Code',
        jobTitle: 'Job Title',
        employer: 'Employer/Company Name',
        address: 'Address: country(territory)/city(town), Street address, Postal code',
        declarationTitle: 'Applicant’s Declaration',
        declaration: 'I hereby declare and confirm that I have truthfully and completely provided all the information required in this assessment questionnaire.\nI authorize and agree that MV may use this information to create my Express Entry (EE) profile.\nI fully understand that any false, inaccurate, incomplete, or misleading information may result in discrepancies between the EE score and the actual situation.\nI voluntarily assume full responsibility for any adverse consequences arising therefrom (including but not limited to application refusal or contract termination) and agree that your company may handle my service eligibility and related fees in accordance with the terms of the contract.',
        signature: 'Signature',
        date: 'Date',
        submit: 'Submit',
        personalInfoTitle: 'Personal Information',
        languageTestTitle: 'Language Test Results',
        englishTestTaken: 'English test taken',
        frenchTestTaken: 'French test taken',
        startDate: 'Start Date (yyyy-mm-dd)',
        endDate: 'End Date (yyyy-mm-dd) or expected'
    },
    fr: {
        title: "Questionnaire Entrée Express - Conjoint",
        switchLabel: 'Basculer en anglais',
        accompany: 'Accompagnerez-vous le demandeur principal au Canada?',
        citizen: 'Êtes-vous citoyen canadien ou résident permanent du Canada?',
        relative: 'Avez-vous un parent qui est citoyen ou résident permanent du Canada (Le parent doit avoir 18 ans ou plus et vivre au Canada.)',
        lastName: 'Nom(s)',
        firstName: 'Prénom(s)',
        gender: 'Sexe',
        dob: 'Date de naissance (aaaa-mm-jj)',
        pob: 'Lieu de naissance (pays/ville)',
        educationTitle: "Historique de l'éducation",
        eduQuestion: "Avez-vous terminé vos études secondaires ou vos études supérieures (y compris une formation universitaire, collégiale ou professionnelle)? Veuillez répondre à toutes les questions suivantes pour chaque période d'études secondaires et postsecondaires :",
        school: "Nom de l'école / institution",
        field: "Domaine d'étude",
        place: "Lieu d'étude (Pays / Province / Ville)",
        postal: 'Code postal',
        duration: 'Durée des études (de–à)',
        languages: 'Langues officielles',
        communicate: 'Pouvez-vous communiquer en anglais et/ou en français?',
        workTitle: 'Historique de travail',
        workingInCanada: 'Travaillez-vous actuellement au Canada?',
        period: 'Période de travail',
        hours: 'Heures par semaine',
        noc: 'Code CNP',
        jobTitle: 'Titre du poste',
        employer: "Employeur / Nom de l'entreprise",
        address: 'Adresse : pays (territoire) / ville, adresse municipale, code postal',
        declarationTitle: 'Déclaration du candidat',
        declaration: 'Je déclare et confirme avoir fourni de manière véridique et complète toutes les informations requises dans le présent questionnaire d’évaluation.\nJ’autorise et consens à ce que MV utilise ces informations pour la création de mon profil Entrée Express (EE).\nJe comprends clairement que toute information fausse, inexacte, incomplète ou trompeuse peut entraîner une discordance entre le score EE et la situation réelle.\nJ’assume volontairement l’entière responsabilité de toute conséquence défavorable en résultant (y compris, sans s’y limiter, un refus de demande ou la résiliation du contrat) et j’accepte que votre société traite mes droits de service et les frais correspondants conformément aux dispositions du contrat.',
        signature: 'Signature',
        date: 'Date',
        submit: 'Soumettre',
        personalInfoTitle: 'Renseignements personnels',
        languageTestTitle: 'Résultats du test de langue',
        englishTestTaken: "Test d'anglais",
        frenchTestTaken: 'Test de français',
        startDate: 'Date de début (aaaa-mm-jj)',
        endDate: 'Date de fin (aaaa-mm-jj) ou prévue'
    }
};

export default function SpouseEEForm({
    formData,
    setFormData,
    lang
}) {
    const handleChange = (field, value) => setFormData({ ...formData, [field]: value });
    return (
       <>
            {/* General Questions */}

            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h4">{t[lang].title}</Typography>
            </Box>
            <Typography variant="h6">{t[lang].accompany}</Typography>
            <FormControl required>
                <RadioGroup row name="accompanyPrincipal" onChange={e => handleChange('accompanyPrincipal', e.target.value)} required>
                    <FormControlLabel value="Yes" control={<Radio required />} label="Yes / Oui" />
                    <FormControlLabel value="No" control={<Radio required />} label="No / Non" />
                </RadioGroup>
            </FormControl>

            <Typography variant="h6">{t[lang].citizen}</Typography>
            <FormControl required>
                <RadioGroup row name="isCanadian" onChange={e => handleChange('isCanadian', e.target.value)}>
                    <FormControlLabel value="Yes" control={<Radio required />} label="Yes / Oui" />
                    <FormControlLabel value="No" control={<Radio required />} label="No / Non" />
                </RadioGroup>
            </FormControl>

            <Typography variant="h6">{t[lang].relative}</Typography>
            <FormControl required>
                <RadioGroup row name="relativeInCanada" onChange={e => handleChange('relativeInCanada', e.target.value)}>
                    <FormControlLabel value="Yes" control={<Radio required />} label="Yes / Oui" />
                    <FormControlLabel value="No" control={<Radio required />} label="No / Non" />
                </RadioGroup>
            </FormControl>

            <Divider sx={{ my: 3 }} />

            {/* Personal Information Section */}
            <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
                {t[lang].personalInfoTitle}
            </Typography>

            {[
                { key: 'lastName', label: t[lang].lastName },
                { key: 'firstName', label: t[lang].firstName },
                { key: 'pob', label: t[lang].pob }
            ].map(f => (
                <TextField required fullWidth key={f.key} label={f.label} onChange={e => handleChange(f.key, e.target.value)} sx={{ my: 1 }} />
            ))}

            <Grid size={{ xs:12 }}>
                <TextField
                    required
                    fullWidth
                    type="date"
                    label={t[lang].dob}
                    slotProps={{
                        inputLabel: {
                            shrink: true
                        }
                    }}
                    onChange={e => handleChange('dob', e.target.value)}
                />
            </Grid>

            {/* Gender Field (Radio Buttons) */}
            <FormControl required fullWidth sx={{ my: 1 }}>
                <FormLabel>{t[lang].gender}</FormLabel>
                <RadioGroup row onChange={e => handleChange('gender', e.target.value)} name="gender">
                    <FormControlLabel value="Male" control={<Radio required />} label={lang === 'en' ? 'Male' : 'Homme'} />
                    <FormControlLabel value="Female" control={<Radio required />} label={lang === 'en' ? 'Female' : 'Femme'} />
                    <FormControlLabel value="Other" control={<Radio required />} label={lang === 'en' ? 'Other' : 'Autre'} />
                </RadioGroup>
            </FormControl>

            <Divider sx={{ my: 3 }} />

            {/* Education */}
            <Typography variant="h5" sx={{ mt: 3 }}>
                {t[lang].educationTitle}
            </Typography>
            <Typography >
                {t[lang].eduQuestion}
            </Typography>
            {formData.educationHistory && formData.educationHistory.length > 0 ? (
                formData.educationHistory.map((entry, index) => (
                    <Paper key={index} elevation={2} sx={{ p: 2, mb: 2, borderRadius: 2, backgroundColor: '#fafafa' }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                            <Typography variant="subtitle2">{lang === 'en' ? `Education ${index + 1}` : `Éducation ${index + 1}`}</Typography>
                            <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={() => {
                                    const updated = [...formData.educationHistory];
                                    updated.splice(index, 1);
                                    handleChange('educationHistory', updated);
                                }}
                            >
                                {lang === 'en' ? 'Delete' : 'Supprimer'}
                            </Button>
                        </Box>

                        {/* Standard Education Fields */}
                        {[
                            { key: 'schoolName', label: t[lang].school },
                            { key: 'field', label: t[lang].field },
                            { key: 'place', label: t[lang].place },
                            { key: 'postalCode', label: t[lang].postal },
                            { key: 'startDate', label: t[lang].startDate },
                            { key: 'endDate', label: t[lang].endDate }
                        ].map(f => (
                            <TextField
                                required
                                fullWidth
                                key={f.key}
                                label={f.label}
                                type={f.key === 'startDate' || f.key === 'endDate' ? 'date' : 'text'}
                                value={entry[f.key] || ''}
                                onChange={e => {
                                    const updated = [...formData.educationHistory];
                                    updated[index] = { ...updated[index], [f.key]: e.target.value };
                                    handleChange('educationHistory', updated);
                                }}
                                sx={{ my: 1 }}
                                slotProps={{
                                    inputLabel: {
                                        shrink: true
                                    }
                                }}
                            />
                        ))}

                        {/* Is this your current study */}
                        <FormControl required sx={{ my: 1 }}>
                            <FormLabel>{lang === 'en' ? 'Is this your current study?' : 'Est-ce votre étude actuelle?'}</FormLabel>
                            <RadioGroup
                                row
                                value={entry.isCurrent}
                                required
                                onChange={e => {
                                    const updated = [...formData.educationHistory];
                                    updated[index] = { ...updated[index], isCurrent: e.target.value };
                                    handleChange('educationHistory', updated);
                                }}
                            >
                                <FormControlLabel value="Yes" control={<Radio required />} label="Yes / Oui" />
                                <FormControlLabel value="No" control={<Radio required />} label="No / Non" />
                            </RadioGroup>
                        </FormControl>

                        <Divider sx={{ borderColor: 'transparent' }} />

                        {/* Study Mode */}
                        <FormControl required sx={{ my: 1 }}>
                            <FormLabel>{lang === 'en' ? 'Is this full-time or part-time study?' : 'Est-ce une étude à temps plein ou à temps partiel?'}</FormLabel>
                            <RadioGroup
                                row
                                required
                                value={entry.studyMode}
                                onChange={e => {
                                    const updated = [...formData.educationHistory];
                                    updated[index] = { ...updated[index], studyMode: e.target.value };
                                    handleChange('educationHistory', updated);
                                }}
                            >
                                <FormControlLabel value="Full-time" control={<Radio required />} label="Full-time / Temps plein" />
                                <FormControlLabel value="Part-time" control={<Radio required />} label="Part-time / Temps partiel" />
                            </RadioGroup>
                        </FormControl>

                        {/* Academic Years */}
                        <TextField
                            required
                            fullWidth
                            label={lang === 'en' ? 'Complete/full academic years' : 'Années académiques complètes'}
                            value={entry.years || ''}
                            onChange={e => {
                                const updated = [...formData.educationHistory];
                                updated[index] = { ...updated[index], years: e.target.value };
                                handleChange('educationHistory', updated);
                            }}
                            sx={{ my: 1 }}
                            slotProps={{ required: false }}
                        />

                        <Divider sx={{ borderColor: 'transparent' }} />

                        {/* Level of Education */}
                        <FormControl required sx={{ my: 1 }}>
                            <FormLabel>{lang === 'en' ? 'Level of education' : 'Niveau de scolarité'}</FormLabel>
                            <RadioGroup
                                required
                                value={entry.level || ''}
                                onChange={e => {
                                    const updated = [...formData.educationHistory];
                                    updated[index] = { ...updated[index], level: e.target.value };
                                    handleChange('educationHistory', updated);
                                }}
                            >
                                {(lang === 'en' ? 
                                [
                                    'Less than secondary school (high school)', 
                                    'Secondary diploma (high school graduation)', 
                                    'One-year degree, diploma or certificate from a university, college, trade or technical school, or other institute', 
                                    'Two-year program at a university, college, trade or technical school, or other institute', 
                                    `Bachelor's degree OR a three or more year program at a university, college, trade or technical school, or other institute`, 
                                    `Two or more certificates, diplomas, or degrees. One must be for a program of three or more years`, 
                                    `Master's degree, OR professional degree needed to practice in a licensed profession (For “professional degree,” the degree program must have been in: medicine, veterinary medicine, dentistry, optometry, law, chiropractic medicine, or pharmacy.)`, 
                                    `Doctoral level university degree (Ph.D.)`
                                ]: 
                                [
                                    "Aucune ou études secondaires non complétées",
                                    "Diplôme d'études secondaire",
                                    "Diplôme d'études postsecondaires nécessitant une année d'études par une université, un collège, une école",
                                    "Diplôme d'études postsecondaires nécessitant deux années d'études par une université, un collège, une école",
                                    "Diplôme d'études postsecondaires nécessitant au moins trois années d'études par une université, un collège, une école",
                                    "Diplôme d'études universitaires de deuxième cycle OU diplôme professionnel de premier échelon",
                                    "Diplôme universitaire de troisième cycle (Ph.D.)"
                                ]).map(lvl => (
                                    <FormControlLabel key={lvl} value={lvl} control={<Radio required />} label={lvl} />
                                ))}
                            </RadioGroup>
                        </FormControl>

                        <Divider sx={{ borderColor: 'transparent' }} />

                        {/* Standing */}
                        <FormControl required sx={{ my: 1 }}>
                            <FormLabel>{lang === 'en' ? 'Standing at the end of study period' : 'Résultats à la fin de la période d’étude'}</FormLabel>
                            <RadioGroup
                                required
                                value={entry.standing || ''}
                                onChange={e => {
                                    const updated = [...formData.educationHistory];
                                    updated[index] = { ...updated[index], standing: e.target.value };
                                    handleChange('educationHistory', updated);
                                }}
                            >
                                {(lang === 'en'
                                    ? [
                                          { value: 'Certificate or diploma or degree awarded', label: 'Certificate/diploma/degree awarded' },
                                          {
                                              value: 'In good standing but no certificate or diploma or degree awarded',
                                              label: 'In good standing but no certificate or diploma or degree awarded'
                                          },
                                          { value: 'Not completed', label: 'Not completed' }
                                      ]
                                    : [
                                          { value: 'Certificat ou diplôme délivré', label: 'Certificat ou diplôme délivré' },
                                          {
                                              value: 'En règle mais aucun certificat ou diplôme délivré',
                                              label: 'En règle mais aucun certificat ou diplôme délivré'
                                          },
                                          { value: 'Inachevées', label: 'Inachevées' }
                                      ]
                                ).map(option => (
                                    <FormControlLabel key={option.value} value={option.value} control={<Radio required />} label={option.label} />
                                ))}
                            </RadioGroup>
                        </FormControl>

                        <Divider sx={{ borderColor: 'transparent' }} />

                        {/* Q11: Canadian Degree Awarded */}
                        <FormControl required sx={{ my: 1 }}>
                            <FormLabel>{lang === 'en' ? 'Were you awarded a Canadian degree, diploma or certificate for this period of study?' : 'Avez-vous obtenu un diplôme, un certificat ou un grade canadien pour cette période d’études?'}</FormLabel>
                            <RadioGroup
                                row
                                required
                                value={entry.canadianAward || ''}
                                onChange={e => {
                                    const updated = [...formData.educationHistory];
                                    updated[index] = { ...updated[index], 
                                        canadianAward: e.target.value,
                                        eca: "",
                                        isPublicOrPrivate: "",
                                        languageCourse: "",
                                        awardReturn: "",
                                        inPerson: "",
                                        monthsInCanada: "",
                                        fullTime8Months: ""
                                    };
                                    handleChange('educationHistory', updated);
                                }}
                            >
                                <FormControlLabel value="Yes" control={<Radio required />} label="Yes / Oui" />
                                <FormControlLabel value="No" control={<Radio required />} label="No / Non" />
                            </RadioGroup>
                        </FormControl>

                        <Divider sx={{ borderColor: 'transparent' }} />

                        {/* If NO → ECA question */}
                        {entry.canadianAward === 'No' && (
                            <FormControl required sx={{ my: 1 }}>
                                <FormLabel>{lang === 'en' ? 
                                'Have you had an Educational Credential Assessment (ECA) within the past five years for this degree, diploma or certificate?' : 
                                `Avez-vous a obtenu une évaluation des diplômes d'études (EDE), produit par un organisme désigné au cours des cinq dernières années, pour ce diplôme, certificat ou titre de compétence étranger?`}</FormLabel>
                                <RadioGroup
                                    row
                                    required
                                    value={entry.eca || ''}
                                    onChange={e => {
                                        const updated = [...formData.educationHistory];
                                        updated[index] = { ...updated[index], eca: e.target.value };
                                        handleChange('educationHistory', updated);
                                    }}
                                >
                                    <FormControlLabel value="Yes" control={<Radio required />} label="Yes / Oui" />
                                    <FormControlLabel value="No" control={<Radio required />} label="No / Non" />
                                </RadioGroup>
                            </FormControl>
                        )}

                        {/* If YES → 6 follow-up questions */}
                        {entry.canadianAward === 'Yes' && (
                            <>
                                {[
                                    {
                                        key: 'isPublicOrPrivate',
                                        en: "Was this degree, diploma or certificate: from a public post-secondary school, such as a college, trade, technical school, university orCEGEP (in Quebec)/from a private post-secondary school that operates under the same rules as public schools/a diplôme d'études professionnelles (DEP) or an attestation de spécialisation professionnelle(ASP) earned through a qualifying study program of at least 900 hours from a private school inQuebec, or/a Bachelor's, Master's or Doctorate degree from a Canadian private school that can legallyaward degrees under provincial law. (The student must have been enrolled in a study program that led to a degree as set out by the province.)?",
                                        fr: `Est-ce que ce diplôme, diplôme ou certificat : Le diplôme ou le certificat:a t il été décerné par un établissement d'enseignement postsecondaire public, comme un collège, une école de métiers, une école technique, une université ou un cégep (au Québec)?/a t il été décerné par un établissement d'enseignement postsecondaire privé régi par les mêmes règles et règlements qu'un établissement public?  /est il un diplôme d'études professionnelles (DEP) ou une attestation de spécialisation professionnelle (ASP) obtenue par l'intermédiaire d'un programme d'études admissible comptant au moins 900 heures offert par une école privée du Québec? /est il un baccalauréat, une maîtrise ou un doctorat décerné par un établissement d'enseignement privé canadien autorisé à décerner des diplômes au titre de la loi provinciale? (L'étudiant doit avoir été inscrit à un programme d'études menant à un diplôme, conformément aux règlements établis par la province.)?`
                                    },
                                    {
                                        key: 'languageCourse',
                                        en: 'Was more than half of the program English or French as a second language?',
                                        fr: `Plus de la moitié du programme d'études était-il en anglais ou en français comme langue seconde?`
                                    },
                                    {
                                        key: 'awardReturn',
                                        en:  "Did you study in Canada based on an award that required them to go back to your home country to apply your knowledge and skills?",
                                        fr: `Avez-vous étudié au Canada sur la base d'un prix qui les obligeait à retourner dans votre pays d'origine pour appliquer vos connaissances et vos compétences?`
                                    },
                                    {
                                        key: 'inPerson',
                                        en: "Did you complete at least 50% of the study or training program's courses through in-person learning?",
                                        fr: `Avez-vous suivi au moins 50 % des cours du programme d'études ou de formation grâce à l'apprentissage en personne?`
                                    },
                                    {
                                        key: 'monthsInCanada',
                                        en: 'Did you study in Canada for at least 8 months for this credential?',
                                        fr: `Avez-vous étudié au Canada pendant au moins 8 mois afin d'obtenir ce grade, diplôme ou certificat?`
                                    },
                                    {
                                        key: 'fullTime8Months',
                                        en: 'Did you study full-time for at least 8 months to earn this degree, diplomaor certificate?',
                                        fr: 'Avez-vous étudié à temps plein pendant au moins 8 mois pour obtenir ce diplôme, certificat de diplomate?'
                                    }
                                ].map(q => (
                                    <>
                                        <FormControl key={q.key} required sx={{ my: 1 }}>
                                            <FormLabel>{lang === 'en' ? q.en : q.fr}</FormLabel>
                                            <RadioGroup
                                                required
                                                row
                                                value={entry[q.key] || ''}
                                                onChange={e => {
                                                    const updated = [...formData.educationHistory];
                                                    updated[index] = { ...updated[index], [q.key]: e.target.value };
                                                    handleChange('educationHistory', updated);
                                                }}
                                            >
                                                <FormControlLabel value="Yes" control={<Radio required />} label="Yes / Oui" />
                                                <FormControlLabel value="No" control={<Radio required />} label="No / Non" />
                                            </RadioGroup>
                                        </FormControl>
                                        <Divider sx={{ borderColor: 'transparent' }} />
                                    </>
                                ))}
                            </>
                        )}
                    </Paper>
                ))
            ) : (
                <Typography color="text.secondary" sx={{ mb: 2 }}>
                    {lang === 'en' ? 'No education history added yet.' : 'Aucun historique d’éducation ajouté.'}
                </Typography>
            )}

            <Button
                variant="contained"
                color="primary"
                onClick={() =>
                    handleChange('educationHistory', [
                        ...(formData.educationHistory || []),
                        {
                            schoolName: '',
                            field: '',
                            place: '',
                            postalCode: '',
                            startDate: '',
                            endDate: '',
                            isCurrent: '',
                            studyMode: '',
                            years: '',
                            level: '',
                            standing: '',
                            canadianAward: '',
                            eca: '',
                            isPublicOrPrivate: '',
                            languageCourse: '',
                            awardReturn: '',
                            inPerson: '',
                            monthsInCanada: '',
                            fullTime8Months: ''
                        }
                    ])
                }
            >
                {lang === 'en' ? 'Add Education History' : 'Ajouter une entrée d’éducation'}
            </Button>

            <Divider sx={{ my: 3 }} />

            {/* Languages */}
            <Typography variant="h5">{t[lang].languages}</Typography>

            <FormLabel required>{t[lang].communicate}</FormLabel>

            <FormGroup row>
                <FormControlLabel control={<Checkbox checked={formData.english || false} onChange={e => handleChange('english', e.target.checked)} name="english" />} label="English" />
                <FormControlLabel control={<Checkbox checked={formData.french || false} onChange={e => handleChange('french', e.target.checked)} name="french" />} label="Français" />
            </FormGroup>

            {/* Show only if both checked */}
            {formData.english && formData.french && (
                <FormControl required>
                    <FormLabel>{lang==='en'?"If both, which language are you most at ease using?(French or English)":"Si les deux, dans quelle langue êtes-vous le plus à l'aise? (français ou anglais)"}</FormLabel>
                    <RadioGroup row name="primaryLanguage" required onChange={e => handleChange('primaryLanguage', e.target.value)}>
                        <FormControlLabel value="English" control={<Radio required />} label="English" />
                        <FormControlLabel value="French" control={<Radio required />} label="Français" />
                    </RadioGroup>
                </FormControl>
            )}

            <Divider sx={{ my: 3 }} />

            {/* Language Tests */}
            <Typography variant="h5" sx={{ mt: 3 }}>
                {t[lang].languageTestTitle}
            </Typography>

            {/* === ENGLISH TEST SECTION === */}
            <FormControl required sx={{ mt: 2 }}>
                <FormLabel>{t[lang].englishTestTaken}</FormLabel>
                <RadioGroup row required name="englishTest" value={formData.englishTest || ''} onChange={e => handleChange('englishTest', e.target.value)}>
                    {['IELTS', 'CELPIP', 'PEARSON', 'Never taken'].map(test => (
                        <FormControlLabel key={test} value={test} control={<Radio required />} label={test} />
                    ))}
                </RadioGroup>
            </FormControl>

            {/* Show inputs only when a valid English test selected */}
            {formData.englishTest && formData.englishTest !== 'Never taken' && (
                <>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid size={{ xs:12, sm:4 }}>
                            <TextField
                                required
                                fullWidth
                                type="date"
                                label={lang === 'en' ? 'Date of language test' : 'Date du test de langue'}
                                slotProps={{
                                    inputLabel: {
                                        shrink: true
                                    },
                                    required: false
                                }}
                                onChange={e => handleChange('englishTestDate', e.target.value)}
                            />
                        </Grid>

                        <Grid size={{ xs:12, sm:4 }}>
                            <TextField
                                required
                                fullWidth
                                type="date"
                                label={lang === 'en' ? 'Date of test results' : 'Date des résultats des tests'}
                                slotProps={{
                                    inputLabel: {
                                        shrink: true
                                    },
                                    required: false
                                }}
                                onChange={e => handleChange('englishResultDate', e.target.value)}
                            />
                        </Grid>

                        <Grid size={{ xs:12, sm:4 }}>
                            <TextField required fullWidth label={lang === 'en' ? 'Certificate number' : 'Numéro de certificat'} slotProps={{ required: false }} onChange={e => handleChange('englishCertNumber', e.target.value)} />
                        </Grid>
                    </Grid>

                    <Typography variant="subtitle1" sx={{ mt: 2 }}>
                        {lang === 'en' ? 'Language test scores:' : 'Résultats du test de langue :'}
                    </Typography>

                    <Grid container spacing={2}>
                        {[
                            { key: 'speaking', en: 'Speaking', fr: 'Expression orale' },
                            { key: 'reading', en: 'Reading', fr: 'Lecture' },
                            { key: 'listening', en: 'Listening', fr: 'Écoute' },
                            { key: 'writing', en: 'Writing', fr: 'Écriture' }
                        ].map(field => (
                            <Grid size={{ xs:12, sm:6 }} key={field.key}>
                                <TextField required fullWidth label={lang === 'en' ? field.en : field.fr} onChange={e => handleChange(`english_${field.key}`, e.target.value)} slotProps={{ required: false }} />
                            </Grid>
                        ))}
                    </Grid>
                </>
            )}

            <Divider sx={{ borderColor: 'transparent' }} />

            {/* === FRENCH TEST SECTION === */}
            <FormControl required sx={{ mt: 3 }}>
                <FormLabel>{t[lang].frenchTestTaken}</FormLabel>
                <RadioGroup required row name="frenchTest" value={formData.frenchTest || ''} onChange={e => handleChange('frenchTest', e.target.value)}>
                    {['TEF', 'TCF', 'Never taken'].map(test => (
                        <FormControlLabel key={test} value={test} control={<Radio required />} label={test} />
                    ))}
                </RadioGroup>
            </FormControl>

            {/* Show inputs only when a valid French test selected */}
            {formData.frenchTest && formData.frenchTest !== 'Never taken' && (
                <>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid size={{ xs:12, sm:4 }}>
                            <TextField
                                required
                                fullWidth
                                type="date"
                                label={lang === 'en' ? 'Date of language test' : 'Date du test de langue'}
                                slotProps={{
                                    inputLabel: {
                                        shrink: true
                                    },
                                    required: false
                                }}
                                onChange={e => handleChange('frenchTestDate', e.target.value)}
                            />
                        </Grid>

                        <Grid size={{ xs:12, sm:4 }}>
                            <TextField
                                required
                                fullWidth
                                type="date"
                                label={lang === 'en' ? 'Date of test results' : 'Date des résultats des tests'}
                                slotProps={{
                                    inputLabel: {
                                        shrink: true
                                    },
                                    required: false
                                }}
                                onChange={e => handleChange('frenchResultDate', e.target.value)}
                            />
                        </Grid>

                        <Grid size={{ xs:12, sm:4 }}>
                            <TextField required fullWidth label={lang === 'en' ? 'Certificate number' : 'Numéro de certificat'} slotProps={{ required: false }} onChange={e => handleChange('frenchCertNumber', e.target.value)} />
                        </Grid>
                    </Grid>

                    <Typography variant="subtitle1" sx={{ mt: 2 }}>
                        {lang === 'en' ? 'Language test scores:' : 'Résultats du test de langue :'}
                    </Typography>

                    <Grid container spacing={2}>
                        {[
                            { key: 'speaking', en: 'Speaking', fr: 'Expression orale' },
                            { key: 'reading', en: 'Reading', fr: 'Lecture' },
                            { key: 'listening', en: 'Listening', fr: 'Écoute' },
                            { key: 'writing', en: 'Writing', fr: 'Écriture' }
                        ].map(field => (
                            <Grid  size={{ xs:12, sm:6 }} key={field.key}>
                                <TextField required fullWidth label={lang === 'en' ? field.en : field.fr} onChange={e => handleChange(`french_${field.key}`, e.target.value)} slotProps={{ required: false }} />
                            </Grid>
                        ))}
                    </Grid>
                </>
            )}

            <Divider sx={{ my: 3 }} />

            {/* Work History */}
            <Typography variant="h5" sx={{ mt: 3 }}>
                {t[lang].workTitle}
            </Typography>

            {/* Currently Working in Canada */}
            <FormControl required sx={{ mt: 1 }}>
                <FormLabel>{t[lang].workingInCanada}</FormLabel>
                <RadioGroup required row name="currentlyWorkingInCanada" value={formData.currentlyWorkingInCanada} onChange={e => handleChange('currentlyWorkingInCanada', e.target.value)}>
                    <FormControlLabel value="Yes" control={<Radio required />} label="Yes / Oui" />
                    <FormControlLabel value="No" control={<Radio required />} label="No / Non" />
                </RadioGroup>
            </FormControl>

            <Typography sx={{ mt: 3 }}>
                {
                    lang==='en'? `Work history:Please answer all the following questions for each periods of work history：` :
                    `Historique de travail : Veuillez répondre à toutes les questions suivantes pour chaque période de l'historique de travail :`
                }
            </Typography>
            {/* Work History Blocks */}
            <Box sx={{ mt: 2 }}>
                {(formData.workHistory || []).map((entry, index) => (
                    <Box
                        key={index}
                        sx={{
                            border: '1px solid #ddd',
                            borderRadius: 2,
                            p: 2,
                            my: 2,
                            backgroundColor: '#fafafa'
                        }}
                    >
                        <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
                            {lang === 'en' ? `Work ${index + 1}` : `Travail ${index + 1}`}
                        </Typography>

                        {/* Work Fields */}
                        {[
                            { key: 'startDate', label: t[lang].startDate },
                            { key: 'endDate', label: t[lang].endDate },
                            { key: 'hoursPerWeek', label: t[lang].hours },
                            { key: 'nocCode', label: t[lang].noc },
                            { key: 'jobTitle', label: t[lang].jobTitle },
                            { key: 'employer', label: t[lang].employer },
                            { key: 'address', label: t[lang].address }
                        ].map(f => {
                            if (f.key === 'endDate' && entry.isCurrentJob) return null;

                            return (
                                <TextField
                                    required={f.key !== 'endDate' || !entry.isCurrentJob}
                                    fullWidth
                                    key={f.key}
                                    label={f.label}
                                    type={f.key === 'startDate' || f.key === 'endDate' ? 'date' : 'text'}
                                    value={entry[f.key] || ''}
                                    onChange={e => {
                                        const updated = [...formData.workHistory];
                                        updated[index] = { ...updated[index], [f.key]: e.target.value };
                                        handleChange('workHistory', updated);
                                    }}
                                    sx={{ my: 1 }}
                                    slotProps={{
                                        required: false,
                                        inputLabel: {
                                            shrink: true
                                        }
                                    }}
                                />
                            );
                        })}

                        {/* Current Job Checkbox */}
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={entry.isCurrentJob || false}
                                    onChange={e => {
                                        const updated = [...formData.workHistory];
                                        updated[index] = {
                                            ...updated[index],
                                            isCurrentJob: e.target.checked,
                                            endDate: e.target.checked ? '' : updated[index].endDate
                                        };
                                        handleChange('workHistory', updated);
                                    }}
                                />
                            }
                            label={lang === 'en' ? 'This is my current job' : 'Ceci est mon emploi actuel'}
                            sx={{ mb: 2 }}
                        />

                        <Divider sx={{ borderColor: 'transparent' }} />

                        {/* Work Experience in Canada */}
                        <FormControl required sx={{ mt: 2 }}>
                            <FormLabel>{lang === 'en' ? 'Is this work experience in Canada?' : 'S’agit-il d’une expérience de travail au Canada?'}</FormLabel>
                            <RadioGroup
                                row
                                value={entry.isCanadianExperience || ''}
                                onChange={e => {
                                    const updated = [...formData.workHistory];
                                    updated[index] = { ...updated[index], 
                                        isCanadianExperience: e.target.value,
                                        legal: "",
                                        fullTimeStudy: "",
                                        permitType: ""
                                    };
                                    handleChange('workHistory', updated);
                                }}
                            >
                                <FormControlLabel value="Yes" control={<Radio required />} label="Yes / Oui" />
                                <FormControlLabel value="No" control={<Radio required />} label="No / Non" />
                            </RadioGroup>
                        </FormControl>

                        {/* Conditionally show Canadian Experience details */}
                        {entry.isCanadianExperience === 'Yes' && (
                            <Box sx={{ pl: 2, borderLeft: '3px solid #ccc', mt: 2 }}>
                                {/* Working Legally */}
                                <FormControl required sx={{ mt: 1 }}>
                                    <FormLabel>{lang === 'en' ? 
                                    `Are you working legally in Canada during this time?(A person must have: been working on a valid work permit or exempt from needing one. Had legal status the whole time they were in Canada, and did not stay longer than the approved time period.)` : 
                                    `Travaillez-vous légalement au Canada pendant cette période? (Une personne doit avoir: avoir travaillé en vertu d'un permis de travail valide ou en être dispensée. Avoir possédé un statut légal pendant toute la période passée au Canada, et ne pas être restée plus longtemps que la période de temps approuvé.`
                                    }</FormLabel>
                                    <RadioGroup
                                        row
                                        value={entry.legal || ''}
                                        onChange={e => {
                                            const updated = [...formData.workHistory];
                                            updated[index] = { ...updated[index], legal: e.target.value };
                                            handleChange('workHistory', updated);
                                        }}
                                    >
                                        <FormControlLabel value="Yes" control={<Radio required />} label="Yes / Oui" />
                                        <FormControlLabel value="No" control={<Radio required />} label="No / Non" />
                                    </RadioGroup>
                                </FormControl>
                                <Divider sx={{ borderColor: 'transparent' }} />

                                {/* Full-time Study */}
                                <FormControl required sx={{ mt: 1 }}>
                                    <FormLabel>{lang === 'en' ? 
                                    `Are you studying full-time while doing this job? (A person must be in class at least 15 hours per week during the academic year to be considered full-time. This includes any period of training in the workplace that is part of the study program.)`: 
                                    `Étudier à temps plein tout en occupant cet emploi?(Une personne doit être en classe au moins 15 heures par semaine pendant l'année scolaire pour être considérée comme étudiante à temps plein. Cela comprend toute période de formation en milieu de travail qui fait partie du programme d'études.)`
                                    }</FormLabel>
                                    <RadioGroup
                                        row
                                        value={entry.fullTimeStudy || ''}
                                        onChange={e => {
                                            const updated = [...formData.workHistory];
                                            updated[index] = { ...updated[index], fullTimeStudy: e.target.value };
                                            handleChange('workHistory', updated);
                                        }}
                                    >
                                        <FormControlLabel value="Yes" control={<Radio required />} label="Yes / Oui" />
                                        <FormControlLabel value="No" control={<Radio required />} label="No / Non" />
                                    </RadioGroup>
                                </FormControl>

                                <Divider sx={{ borderColor: 'transparent' }} />

                                {/* Permit Type */}
                                <FormControl required sx={{ mt: 1 }}>
                                    <FormLabel>{lang === 'en' ? 'Which of these categories does your job fall under?' : 'Dans quelle catégorie se classe votre emploi?'}</FormLabel>
                                    <RadioGroup
                                        required
                                        value={entry.permitType || ''}
                                        onChange={e => {
                                            const updated = [...formData.workHistory];
                                            updated[index] = { ...updated[index], permitType: e.target.value };
                                            handleChange('workHistory', updated);
                                        }}
                                    >
                                        {(lang === 'en' ? ['No work permit required', 'Work permit required, no LMIA required', 'Work permit and LMIA required'] : ['Aucun permis de travail requis', 'Permis de travail requis, aucune EIMT requise', 'Permis de travail et EIMT requis']).map(option => (
                                            <FormControlLabel key={option} value={option} control={<Radio required />} label={option} />
                                        ))}
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                        )}
                        <Divider sx={{ borderColor: 'transparent' }} />

                        {/* Delete Button */}
                        <Box textAlign="right" sx={{ mt: 2 }}>
                            <Button
                                variant="outlined"
                                color="error"
                                onClick={() => {
                                    const updated = [...formData.workHistory];
                                    updated.splice(index, 1);
                                    handleChange('workHistory', updated);
                                }}
                            >
                                {lang === 'en' ? 'Delete Work History' : 'Supprimer une expérience de travail'}
                            </Button>
                        </Box>
                    </Box>
                ))}

                {/* Add New Work History Button */}
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() =>
                        handleChange('workHistory', [
                            ...(formData.workHistory || []),
                            {
                                startDate: '',
                                endDate: '',
                                hoursPerWeek: '',
                                nocCode: '',
                                jobTitle: '',
                                employer: '',
                                address: '',
                                isCurrentJob: false,
                                isCanadianExperience: '',
                                legal: '',
                                fullTimeStudy: '',
                                permitType: ''
                            }
                        ])
                    }
                >
                    {lang === 'en' ? 'Add Work History' : 'Ajouter une expérience de travail'}
                </Button>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Declaration */}
            <Typography variant="h5">{t[lang].declarationTitle}</Typography>
            <Typography whiteSpace="pre-line" sx={{ mb: 2 }}>
                {t[lang].declaration}
            </Typography>
            <TextField required fullWidth label={t[lang].signature} sx={{ mb: 2 }} />
            <TextField
                required
                fullWidth
                type="date"
                label={t[lang].date}
                value={formData.declarationDate || ''}
                onChange={e => handleChange('declarationDate', e.target.value)}
                sx={{ mb: 2 }}
                slotProps={{
                    inputLabel: {
                        shrink: true
                    },
                    required: false
                }}
            />
        </>
    );
}
